/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_area_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Several numeric columns draw overlapping translucent areas.`)
};

const es_area_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Varias columnas numéricas dibujan áreas translúcidas superpuestas.`)
};

const de_area_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mehrere numerische Spalten zeichnen überlappende durchscheinende Flächen.`)
};

const nl_area_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meerdere numerieke kolommen tekenen overlappende doorschijnende vlakken.`)
};

const fr_area_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plusieurs colonnes numériques dessinent des aires translucides superposées.`)
};

const it_area_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diverse colonne numeriche disegnano aree traslucide sovrapposte.`)
};

const pt_br2_area_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Várias colunas numéricas desenham áreas translúcidas sobrepostas.`)
};

const pt_area_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Várias colunas numéricas desenham áreas translúcidas sobrepostas.`)
};

const ja_area_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`複数の数値列があると、重なり合った半透明のエリアが描画されます。`)
};

const zh_area_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`多列数值绘制出多个重叠的半透明面积。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const area_ex2 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.area_ex2(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("area_ex2", locale)
	if (locale === "en") return en_area_ex2(inputs)
	if (locale === "es") return es_area_ex2(inputs)
	if (locale === "de") return de_area_ex2(inputs)
	if (locale === "nl") return nl_area_ex2(inputs)
	if (locale === "fr") return fr_area_ex2(inputs)
	if (locale === "it") return it_area_ex2(inputs)
	if (locale === "pt-BR") return pt_br2_area_ex2(inputs)
	if (locale === "pt") return pt_area_ex2(inputs)
	if (locale === "ja") return ja_area_ex2(inputs)
	return zh_area_ex2(inputs)
};